import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './areas/page-not-found/page-not-found.component';

const routes: Routes = [];

@NgModule({

  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 65],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
